import { API } from './index';
import { LOCAL_STORAGE } from '../../utils/utils.constant';
import { sanitizeParams } from '../../utils/auth/check-params';
import { API_ENDPOINTS } from './api-endpoints.constant';
import { AnalyticsUtils } from '../../utils/analytics/AnalyticsUtils';
class AuthService {
    constructor() {
        this.http = API;
    }
    async hashString(message) {
        const msgBuffer = new TextEncoder().encode(message);
        const hashBuffer = await crypto.subtle.digest('SHA-256', msgBuffer);
        const hashArray = Array.from(new Uint8Array(hashBuffer));
        return hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
    }
    emailLogin(data) {
        return this.http
            .withMetadata({
            Pagetype: AnalyticsUtils.getPage(),
            Url: sanitizeParams(),
        })
            .post(API_ENDPOINTS.LOGIN, data);
    }
    async otpEmailLogin(data) {
        const hashedUserId = await this.hashString(data.userid);
        return this.http
            .withMetadata({
            Pagetype: AnalyticsUtils.getPage(),
            Url: sanitizeParams(),
        })
            .post(API_ENDPOINTS.OTP_LOGIN(hashedUserId), data);
    }
    async otpResendEmailLogin(data) {
        return this.http
            .withMetadata({
            Pagetype: AnalyticsUtils.getPage(),
            Url: sanitizeParams(),
        })
            .post(API_ENDPOINTS.OTP_LOGIN_RESEND(data.auth_session), data);
    }
    async otpEmailLoginVerify(data) {
        return this.http
            .withMetadata({
            Pagetype: AnalyticsUtils.getPage(),
            Url: sanitizeParams(),
        })
            .post(API_ENDPOINTS.OTP_LOGIN_VERIFY(data.auth_session), data);
    }
    emailSignup(data) {
        return this.http
            .withMetadata({
            button_position: window.atob(localStorage.getItem(LOCAL_STORAGE.BUTTON_POSITION)),
            Pagetype: AnalyticsUtils.getPage(),
            Url: sanitizeParams(),
        })
            .post(API_ENDPOINTS.EMAIL_SIGNUP, data);
    }
    async otpEmailSignup(data) {
        const hashedEmailId = await this.hashString(data.email);
        return this.http
            .withMetadata({
            button_position: window.atob(localStorage.getItem(LOCAL_STORAGE.BUTTON_POSITION)),
            Pagetype: AnalyticsUtils.getPage(),
            Url: sanitizeParams(),
        })
            .post(API_ENDPOINTS.OTP_SIGNUP(hashedEmailId), data);
    }
    async otpResendEmailSignup(data) {
        return this.http
            .withMetadata({
            button_position: window.atob(localStorage.getItem(LOCAL_STORAGE.BUTTON_POSITION)),
            Pagetype: AnalyticsUtils.getPage(),
            Url: sanitizeParams(),
        })
            .post(API_ENDPOINTS.OTP_SIGNUP_RESEND(data.auth_session), data);
    }
    async otpEmailSignupVerify(data) {
        return this.http
            .withMetadata({
            button_position: window.atob(localStorage.getItem(LOCAL_STORAGE.BUTTON_POSITION)),
            Pagetype: AnalyticsUtils.getPage(),
            Url: sanitizeParams(),
        })
            .post(API_ENDPOINTS.OTP_SIGNUP_VERIFY(data.auth_session), data);
    }
    forgotPassword(data) {
        return this.http.post(API_ENDPOINTS.SEND_RESET_PASSWORD, data);
    }
    getCompleteUserDetails() {
        return this.http.get(API_ENDPOINTS.USER_DETAILS);
    }
    static getInstance() {
        if (!this.instance) {
            this.instance = new AuthService();
        }
        return this.instance;
    }
}
const Auth = AuthService.getInstance();
export { Auth };
